/* eslint-disable */
// prettier-ignore

export const messages = {
  validity_period_is_start_switch: "Ist Start?",
  validity_period_start: "Start",
  validity_period_valid_from: "Gültig ab",
  validity_period_is_end_switch: "Ist Ende?",
  validity_period_end: "Ende",
  validity_period_valid_until: "Gültig bis",
  validity_add_version: "Version hinzufügen",
  validity_period_initial_version: "Erstversion",
  validity_period_set_starting_version_date: "Startdatum für die Anfangsversion festlegen",
  validity_period_starting_from: "Beginnend ab",
  validity_period_starting_date: "Version Start Datum",

  action_dialog_processing_info: "Die Verarbeitung kann einige Zeit in Anspruch nehmen. Wenn Sie nicht warten möchten, können Sie diesen Dialog schließen und den Status später auf der Aktionsseite überprüfen.",
  action_dialog_creation_error: "Unerwarteter Fehler beim Erstellen der Aktion.",
  action_dialog_polling_error: "Unerwarteter Fehler beim Abrufen des Aktionsstatus. Bitte navigieren Sie zur Aktionsseite, um den Status zu überprüfen.",
  action_dialog_cancelled: "Aktion abgebrochen.",
  action_dialog_failed: "Aktion fehlgeschlagen.",
  action_dialog_succeeded: "Aktion abgeschlossen.",
  action_dialog_downloadable_files: "Datei Downloads:"
};
